export var valuesHighScoreMode = ["Optional", "Mandatory", "None"];
/*

*/ 
//# sourceMappingURL=HighScoreMode.js.map